import { render, staticRenderFns } from "./RecipientForm.vue?vue&type=template&id=2649fcf2&scoped=true"
import script from "./RecipientForm.vue?vue&type=script&lang=js"
export * from "./RecipientForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2649fcf2",
  null
  
)

export default component.exports